import React from "react";

const BackgroundVideo = ({ videoSrc }) => {
    return (
        <div className="relative h-screen overflow-hidden">
            <video
                className="absolute top-0 left-0 w-full h-full object-cover"
                src={videoSrc}
                autoPlay
                loop
                muted
            />
            <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20"></div>
            <div className="relative z-10 flex justify-center items-center h-full">
                <h1 className="text-white text-4xl font-bold">Ecklypce</h1>
            </div>
        </div>
    );
};

export default BackgroundVideo;